var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-loading text-xs-center"},[_c('v-progress-circular',{attrs:{"size":50,"color":"primary","indeterminate":""}}),_c('div',[_vm._v("Загрузка...")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }